/* global debounce */
if (!customElements.get("cart-note")) {
  class CartNote extends HTMLElement {
    constructor() {
      super();
      this.disclosure = this.closest("details");

      if (this.disclosure && this.disclosure.matches(".cart-note-disclosure")) {
        this.cartNoteToggle = this.disclosure.querySelector(".js-show-note");
      }

      this.fetchRequestOpts = {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      };

      this.init();
    }

    init() {
      this.debouncedHandleNoteChange = debounce(
        this.handleNoteChange.bind(this),
        300,
      );
      // Save as soon as possible, avoid link-click not providing time to save
      this.addEventListener("input", this.debouncedHandleNoteChange);
    }

    handleNoteChange(evt) {
      if (this.cartNoteToggle) {
        const label = evt.target.value
          ? theme.strings.editCartNote
          : theme.strings.addCartNote;
        if (this.cartNoteToggle.textContent !== label)
          this.cartNoteToggle.textContent = label;
      }

      // When on the main cart page the engraving block must be appended so it
      // is not lost between keystrokes. Read the separator keyword and the
      // current engraving data from the elements written by engraving-cart-note.js.
      let note = evt.target.value;
      const engravingDataEl = document.getElementById("engraving-data");
      const noteDataEl = document.getElementById("engraving-cart-note-data");
      if (engravingDataEl && noteDataEl) {
        try {
          const noteData = JSON.parse(noteDataEl.textContent);
          const separatorKeyword = noteData.noteSeparator || "[GRAVURDATEN]";
          const separator = "\n\n" + separatorKeyword + "\n\n";
          const engravingData = engravingDataEl.value.trim();
          if (engravingData) {
            note = note + (note ? separator : "") + engravingData;
          }
        } catch (_) {
          // Not in an engraving context — send the customer note as-is.
        }
      }

      this.fetchRequestOpts.body = JSON.stringify({ note });
      fetch(theme.routes.cartUpdate, this.fetchRequestOpts);
    }
  }

  customElements.define("cart-note", CartNote);
}
